// extracted by mini-css-extract-plugin
export var statItem = "_f3-1";
export var statsRow = "_f3-0";